module.exports = __webpack_public_path__ + "media/images/bg-audioplayer-m-ad4c4b3807bc18fcbd79dbf8d76eadd9.png";